/**
 * @generated SignedSource<<a192ce9939f08f3273c81b2ed09887b3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type versionGroupHeader_issueTableGrouping$data = {
  readonly displayName: string;
  readonly version: {
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "versionGroupHeader_issueTableGrouping";
};
export type versionGroupHeader_issueTableGrouping$key = {
  readonly " $data"?: versionGroupHeader_issueTableGrouping$data;
  readonly " $fragmentSpreads": FragmentRefs<"versionGroupHeader_issueTableGrouping">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "versionGroupHeader_issueTableGrouping",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "displayName"
    },
    {
      "concreteType": "JiraVersion",
      "kind": "LinkedField",
      "name": "version",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        }
      ]
    }
  ],
  "type": "JiraJqlVersionFieldValue"
};

(node as any).hash = "6f40702033c0b53530dbd612b74690ed";

export default node;
